import * as isPlainObject from 'is-plain-object';

export const isDebuggingEnabled = () => {
  let search = window.location.search;
  return search.substring(1).split('&').includes('debug=true');
};

export const isDev = () => process.env.isDev || isDebuggingEnabled();

export const isAdminSite = () => {
  const regex = /^(dashboard|admin([0-9]+)?)\.[0-9a-z].*/gm;
  return !isNull(regex.exec(window.location.host));
};

export const isWebView = () => window.navigator.userAgent.indexOf('MTWebView') > -1;

export const isObject = (obj: any) => isPlainObject.isPlainObject(obj);

export const isUndefined = (value: any) => typeof value === 'undefined';

export const isPrunable = (elem: any) => Array.isArray(elem) || isObject(elem);

export const hasValue = (elem: any) => !(isUndefined(elem) || elem === null);

export const isNull = (value: any) => value === null;

export const isString = (value: any) => typeof value === 'string';

export const prune = (elem: any) => {
  if (!isPrunable(elem)) return elem;

  if (Array.isArray(elem)) {
    return elem.reduce((acc, val) => {
      if (hasValue(val)) {
        const newVal = isPrunable(val) ? prune(val) : val;
        acc.push(newVal);
      }
      return acc;
    }, []);
  }

  if (isObject(elem)) {
    return Object.keys(elem).reduce((acc: { [key: string]: any }, key) => {
      const val = elem[key];
      if (hasValue(val)) {
        const newVal = isPrunable(val) ? prune(val) : val;
        acc[key] = newVal;
      }
      return acc;
    }, {});
  }
};

function isNullOrUndefined(x: any) {
  return isUndefined(x) || isNull(x);
}

function isEmptyObject(x: any) {
  return isObject(x) && !Object.keys(x).length;
}

function isEmptyArray(x: any) {
  return Array.isArray(x) && !x.length;
}

export function isEmpty(x: any) {
  if (isEmptyObject(x) || isEmptyArray(x)) return true;
  if (isString(x) && !x.length) return true;
  return isNullOrUndefined(x);
}

export function getHighResolutionTime() {
  const performanceTime = performance?.now?.();
  if (isUndefined(performanceTime)) {
    return Date.now();
  }

  return performanceTime;
}
